// Traduções de Sinistros, a tela do Abastecimento e a leitura do DP (01/11/2026).
// Coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'sinistros.titulo': 'Sinistros',
    'sinistros.eyebrow': 'Abastecimento',
    'sinistros.ajuda.lancamento': 'O setor de abastecimento lança cada sinistro com o veículo, o condutor, o responsável e os comprovantes. O sinistro cai no DP, que só consulta. Com o responsável motorista, ele derruba o requisito do bônus na competência da data.',
    'sinistros.ajuda.dp': 'Os sinistros que o setor de abastecimento lança, com o condutor, o responsável, o desconto proposto e os comprovantes. O DP consulta; quem lança e corrige é o abastecimento.',
    'sinistros.kpi.total': 'Lançados',
    'sinistros.kpi.valor': 'Valor estimado',
    'sinistros.kpi.desconto': 'A descontar',
    'sinistros.kpi.sem_condutor': 'Sem condutor',
    'sinistros.kpi.sem_comprovante': 'Sem comprovante',
    'sinistros.kpi.com_vitima': 'Com vítima',
    'sinistros.lancar': 'Lançar sinistro',
    'sinistros.lancarCurto': 'Lançar',
    'sinistros.excel': 'Excel',
    'sinistros.busca': 'Placa, condutor ou número',
    'sinistros.filtro.de': 'De',
    'sinistros.filtro.ate': 'Até',
    'sinistros.filtro.tipo': 'Tipo',
    'sinistros.filtro.responsavel': 'Responsável',
    'sinistros.filtro.situacao': 'Situação',
    'sinistros.filtro.todos': 'Todos',
    'sinistros.situacao.lancado': 'Lançados',
    'sinistros.situacao.cancelado': 'Cancelados',
    'sinistros.situacao.todos': 'Todos',
    'sinistros.col.ocorrencia': 'Ocorrência',
    'sinistros.col.tipo': 'Tipo',
    'sinistros.col.veiculo': 'Veículo',
    'sinistros.col.condutor': 'Condutor',
    'sinistros.col.valores': 'Valores',
    'sinistros.col.acoes': 'Ações',
    'sinistros.tipo.colisao': 'Colisão',
    'sinistros.tipo.tombamento': 'Tombamento',
    'sinistros.tipo.saida_de_pista': 'Saída de pista',
    'sinistros.tipo.avaria': 'Avaria',
    'sinistros.tipo.roubo_furto': 'Roubo ou furto',
    'sinistros.tipo.incendio': 'Incêndio',
    'sinistros.tipo.outro': 'Outro',
    'sinistros.responsavel.motorista': 'Motorista',
    'sinistros.responsavel.empresa': 'Empresa',
    'sinistros.responsavel.terceiro': 'Terceiro',
    'sinistros.semNumero': 'Sem número',
    'sinistros.semCondutor': 'Sem condutor',
    'sinistros.semDesconto': 'Sem desconto',
    'sinistros.comVitima': 'Com vítima',
    'sinistros.cancelado': 'Cancelado',
    'sinistros.comprovantes': '{{n}} comprovantes',
    'sinistros.ver': 'Ver',
    'sinistros.editar': 'Editar',
    'sinistros.cancelar': 'Cancelar sinistro',
    'sinistros.fechar': 'Fechar',
    'sinistros.semResultado': 'Nenhum sinistro neste filtro',
    'sinistros.secao.ocorrencia': 'Ocorrência',
    'sinistros.secao.veiculo': 'Veículo e condutor',
    'sinistros.secao.desconto': 'Valor e desconto',
    'sinistros.secao.comprovantes': 'Comprovantes',
    'sinistros.campo.numero': 'Boletim ou protocolo',
    'sinistros.campo.dataHora': 'Data e hora da ocorrência',
    'sinistros.campo.tipo': 'Tipo',
    'sinistros.campo.comVitima': 'Com vítima',
    'sinistros.campo.descricao': 'Descrição',
    'sinistros.campo.local': 'Local',
    'sinistros.campo.municipio': 'Município',
    'sinistros.campo.uf': 'UF',
    'sinistros.campo.veiculo': 'Veículo',
    'sinistros.campo.condutor': 'Condutor',
    'sinistros.campo.valorEstimado': 'Valor estimado',
    'sinistros.campo.responsavel': 'Responsável',
    'sinistros.campo.valorDesconto': 'Valor a descontar',
    'sinistros.campo.observacao': 'Observação ao DP',
    'sinistros.form.tituloNovo': 'Lançar sinistro',
    'sinistros.form.tituloEdicao': 'Editar o sinistro {{numero}}',
    'sinistros.form.lancar': 'Lançar',
    'sinistros.form.salvar': 'Salvar',
    'sinistros.form.obrigatorio': 'Informe a data e a hora, o tipo, o veículo e o responsável.',
    'sinistros.form.motoristaSemCondutor': 'Sem condutor identificado, o sinistro não entra no bônus de ninguém.',
    'sinistros.form.enviando': 'Enviando comprovante {{atual}} de {{total}}',
    'sinistros.form.falhou': 'O sinistro está salvo, mas alguns comprovantes não subiram. Tente de novo.',
    'sinistros.form.salvo': 'Sinistro salvo',
    'sinistros.form.lancado': 'Sinistro lançado',
    'sinistros.anexoLimite': 'O sinistro já tem 10 comprovantes',
    'sinistros.anexoRemovido': 'Comprovante removido',
    'sinistros.detalhe.lancadoPor': 'Lançado por {{nome}} em {{data}}',
    'sinistros.detalhe.atualizadoPor': 'Atualizado por {{nome}} em {{data}}',
    'sinistros.detalhe.canceladoPor': 'Cancelado por {{nome}} em {{data}}',
    'sinistros.cancelarDialogo.titulo': 'Cancelar o sinistro {{numero}}',
    'sinistros.cancelarDialogo.explica': 'O sinistro sai dos lançados e do DP, deixa de contar na próxima apuração do bônus, e fica no histórico com o motivo.',
    'sinistros.cancelarDialogo.motivo': 'Motivo',
    'sinistros.cancelarDialogo.ok': 'Sinistro cancelado',
  },
  en: {
    'sinistros.titulo': 'Claims',
    'sinistros.eyebrow': 'Fueling',
    'sinistros.ajuda.lancamento': 'The fueling team enters each claim with the vehicle, the driver, the responsible party and the receipts. The claim reaches the Personnel Department, which only views it. With the driver as the responsible party, it breaks the bonus requirement in the pay period of the date.',
    'sinistros.ajuda.dp': 'The claims entered by the fueling team, with the driver, the responsible party, the proposed deduction and the receipts. The Personnel Department views them; the fueling team enters and corrects.',
    'sinistros.kpi.total': 'Entered',
    'sinistros.kpi.valor': 'Estimated amount',
    'sinistros.kpi.desconto': 'To deduct',
    'sinistros.kpi.sem_condutor': 'No driver',
    'sinistros.kpi.sem_comprovante': 'No receipt',
    'sinistros.kpi.com_vitima': 'With victim',
    'sinistros.lancar': 'Enter claim',
    'sinistros.lancarCurto': 'Enter',
    'sinistros.excel': 'Excel',
    'sinistros.busca': 'Plate, driver or number',
    'sinistros.filtro.de': 'From',
    'sinistros.filtro.ate': 'To',
    'sinistros.filtro.tipo': 'Type',
    'sinistros.filtro.responsavel': 'Responsible party',
    'sinistros.filtro.situacao': 'Status',
    'sinistros.filtro.todos': 'All',
    'sinistros.situacao.lancado': 'Entered',
    'sinistros.situacao.cancelado': 'Canceled',
    'sinistros.situacao.todos': 'All',
    'sinistros.col.ocorrencia': 'Occurrence',
    'sinistros.col.tipo': 'Type',
    'sinistros.col.veiculo': 'Vehicle',
    'sinistros.col.condutor': 'Driver',
    'sinistros.col.valores': 'Amounts',
    'sinistros.col.acoes': 'Actions',
    'sinistros.tipo.colisao': 'Collision',
    'sinistros.tipo.tombamento': 'Rollover',
    'sinistros.tipo.saida_de_pista': 'Run off the road',
    'sinistros.tipo.avaria': 'Damage',
    'sinistros.tipo.roubo_furto': 'Theft or robbery',
    'sinistros.tipo.incendio': 'Fire',
    'sinistros.tipo.outro': 'Other',
    'sinistros.responsavel.motorista': 'Driver',
    'sinistros.responsavel.empresa': 'Company',
    'sinistros.responsavel.terceiro': 'Third party',
    'sinistros.semNumero': 'No number',
    'sinistros.semCondutor': 'No driver',
    'sinistros.semDesconto': 'No deduction',
    'sinistros.comVitima': 'With victim',
    'sinistros.cancelado': 'Canceled',
    'sinistros.comprovantes': '{{n}} receipts',
    'sinistros.ver': 'View',
    'sinistros.editar': 'Edit',
    'sinistros.cancelar': 'Cancel claim',
    'sinistros.fechar': 'Close',
    'sinistros.semResultado': 'No claims in this filter',
    'sinistros.secao.ocorrencia': 'Occurrence',
    'sinistros.secao.veiculo': 'Vehicle and driver',
    'sinistros.secao.desconto': 'Amount and deduction',
    'sinistros.secao.comprovantes': 'Receipts',
    'sinistros.campo.numero': 'Police report or protocol',
    'sinistros.campo.dataHora': 'Occurrence date and time',
    'sinistros.campo.tipo': 'Type',
    'sinistros.campo.comVitima': 'With victim',
    'sinistros.campo.descricao': 'Description',
    'sinistros.campo.local': 'Location',
    'sinistros.campo.municipio': 'City',
    'sinistros.campo.uf': 'State',
    'sinistros.campo.veiculo': 'Vehicle',
    'sinistros.campo.condutor': 'Driver',
    'sinistros.campo.valorEstimado': 'Estimated amount',
    'sinistros.campo.responsavel': 'Responsible party',
    'sinistros.campo.valorDesconto': 'Amount to deduct',
    'sinistros.campo.observacao': 'Note to Personnel',
    'sinistros.form.tituloNovo': 'Enter claim',
    'sinistros.form.tituloEdicao': 'Edit claim {{numero}}',
    'sinistros.form.lancar': 'Enter',
    'sinistros.form.salvar': 'Save',
    'sinistros.form.obrigatorio': 'Enter the date and time, the type, the vehicle and the responsible party.',
    'sinistros.form.motoristaSemCondutor': 'With no driver identified, the claim does not reach anyone\'s bonus.',
    'sinistros.form.enviando': 'Uploading receipt {{atual}} of {{total}}',
    'sinistros.form.falhou': 'The claim is saved, but some receipts did not upload. Try again.',
    'sinistros.form.salvo': 'Claim saved',
    'sinistros.form.lancado': 'Claim entered',
    'sinistros.anexoLimite': 'The claim already has 10 receipts',
    'sinistros.anexoRemovido': 'Receipt removed',
    'sinistros.detalhe.lancadoPor': 'Entered by {{nome}} on {{data}}',
    'sinistros.detalhe.atualizadoPor': 'Updated by {{nome}} on {{data}}',
    'sinistros.detalhe.canceladoPor': 'Canceled by {{nome}} on {{data}}',
    'sinistros.cancelarDialogo.titulo': 'Cancel claim {{numero}}',
    'sinistros.cancelarDialogo.explica': 'The claim leaves the entered list and the Personnel view, stops counting in the next bonus calculation, and stays in the history with the reason.',
    'sinistros.cancelarDialogo.motivo': 'Reason',
    'sinistros.cancelarDialogo.ok': 'Claim canceled',
  },
  es: {
    'sinistros.titulo': 'Siniestros',
    'sinistros.eyebrow': 'Abastecimiento',
    'sinistros.ajuda.lancamento': 'El sector de abastecimiento registra cada siniestro con el vehículo, el conductor, el responsable y los comprobantes. El siniestro llega al departamento de personal, que solo lo consulta. Con el conductor como responsable, incumple el requisito del bono en el período de la fecha.',
    'sinistros.ajuda.dp': 'Los siniestros que registra el sector de abastecimiento, con el conductor, el responsable, el descuento propuesto y los comprobantes. Personal consulta; abastecimiento registra y corrige.',
    'sinistros.kpi.total': 'Registrados',
    'sinistros.kpi.valor': 'Valor estimado',
    'sinistros.kpi.desconto': 'A descontar',
    'sinistros.kpi.sem_condutor': 'Sin conductor',
    'sinistros.kpi.sem_comprovante': 'Sin comprobante',
    'sinistros.kpi.com_vitima': 'Con víctima',
    'sinistros.lancar': 'Registrar siniestro',
    'sinistros.lancarCurto': 'Registrar',
    'sinistros.excel': 'Excel',
    'sinistros.busca': 'Placa, conductor o número',
    'sinistros.filtro.de': 'Desde',
    'sinistros.filtro.ate': 'Hasta',
    'sinistros.filtro.tipo': 'Tipo',
    'sinistros.filtro.responsavel': 'Responsable',
    'sinistros.filtro.situacao': 'Situación',
    'sinistros.filtro.todos': 'Todos',
    'sinistros.situacao.lancado': 'Registrados',
    'sinistros.situacao.cancelado': 'Cancelados',
    'sinistros.situacao.todos': 'Todos',
    'sinistros.col.ocorrencia': 'Ocurrencia',
    'sinistros.col.tipo': 'Tipo',
    'sinistros.col.veiculo': 'Vehículo',
    'sinistros.col.condutor': 'Conductor',
    'sinistros.col.valores': 'Valores',
    'sinistros.col.acoes': 'Acciones',
    'sinistros.tipo.colisao': 'Colisión',
    'sinistros.tipo.tombamento': 'Vuelco',
    'sinistros.tipo.saida_de_pista': 'Salida de pista',
    'sinistros.tipo.avaria': 'Avería',
    'sinistros.tipo.roubo_furto': 'Robo o hurto',
    'sinistros.tipo.incendio': 'Incendio',
    'sinistros.tipo.outro': 'Otro',
    'sinistros.responsavel.motorista': 'Conductor',
    'sinistros.responsavel.empresa': 'Empresa',
    'sinistros.responsavel.terceiro': 'Tercero',
    'sinistros.semNumero': 'Sin número',
    'sinistros.semCondutor': 'Sin conductor',
    'sinistros.semDesconto': 'Sin descuento',
    'sinistros.comVitima': 'Con víctima',
    'sinistros.cancelado': 'Cancelado',
    'sinistros.comprovantes': '{{n}} comprobantes',
    'sinistros.ver': 'Ver',
    'sinistros.editar': 'Editar',
    'sinistros.cancelar': 'Cancelar siniestro',
    'sinistros.fechar': 'Cerrar',
    'sinistros.semResultado': 'Ningún siniestro en este filtro',
    'sinistros.secao.ocorrencia': 'Ocurrencia',
    'sinistros.secao.veiculo': 'Vehículo y conductor',
    'sinistros.secao.desconto': 'Valor y descuento',
    'sinistros.secao.comprovantes': 'Comprobantes',
    'sinistros.campo.numero': 'Denuncia o protocolo',
    'sinistros.campo.dataHora': 'Fecha y hora de la ocurrencia',
    'sinistros.campo.tipo': 'Tipo',
    'sinistros.campo.comVitima': 'Con víctima',
    'sinistros.campo.descricao': 'Descripción',
    'sinistros.campo.local': 'Lugar',
    'sinistros.campo.municipio': 'Municipio',
    'sinistros.campo.uf': 'Estado',
    'sinistros.campo.veiculo': 'Vehículo',
    'sinistros.campo.condutor': 'Conductor',
    'sinistros.campo.valorEstimado': 'Valor estimado',
    'sinistros.campo.responsavel': 'Responsable',
    'sinistros.campo.valorDesconto': 'Valor a descontar',
    'sinistros.campo.observacao': 'Observación para Personal',
    'sinistros.form.tituloNovo': 'Registrar siniestro',
    'sinistros.form.tituloEdicao': 'Editar el siniestro {{numero}}',
    'sinistros.form.lancar': 'Registrar',
    'sinistros.form.salvar': 'Guardar',
    'sinistros.form.obrigatorio': 'Informe la fecha y la hora, el tipo, el vehículo y el responsable.',
    'sinistros.form.motoristaSemCondutor': 'Sin conductor identificado, el siniestro no llega al bono de nadie.',
    'sinistros.form.enviando': 'Enviando comprobante {{atual}} de {{total}}',
    'sinistros.form.falhou': 'El siniestro está guardado, pero algunos comprobantes no subieron. Intente de nuevo.',
    'sinistros.form.salvo': 'Siniestro guardado',
    'sinistros.form.lancado': 'Siniestro registrado',
    'sinistros.anexoLimite': 'El siniestro ya tiene 10 comprobantes',
    'sinistros.anexoRemovido': 'Comprobante quitado',
    'sinistros.detalhe.lancadoPor': 'Registrado por {{nome}} el {{data}}',
    'sinistros.detalhe.atualizadoPor': 'Actualizado por {{nome}} el {{data}}',
    'sinistros.detalhe.canceladoPor': 'Cancelado por {{nome}} el {{data}}',
    'sinistros.cancelarDialogo.titulo': 'Cancelar el siniestro {{numero}}',
    'sinistros.cancelarDialogo.explica': 'El siniestro sale de los registrados y de Personal, deja de contar en el próximo cálculo del bono, y queda en el historial con el motivo.',
    'sinistros.cancelarDialogo.motivo': 'Motivo',
    'sinistros.cancelarDialogo.ok': 'Siniestro cancelado',
  },
}
